/*
 * @Author: zhangguoliang
 * @Date: 2022-11-26 21:37:21
 * @LastEditors: zhangguoliang
 * @LastEditTime: 2022-11-26 23:18:48
 */
import Cookies from "js-cookie";

export function logout() {
  const cookies = Cookies.get() || {};
  Object.keys(cookies)
    .filter((k) => k.includes("token"))
    .forEach((item) => {
      Cookies.remove(item);
    });
  location.href = "/login";
}
